import { Injectable } from '@angular/core';
import { enviroment } from 'src/environments/environment';
import { IMAGE_SIZES, ImageSizeKey } from '../model/image-sizes';

@Injectable({ providedIn: 'root' })
export class ImageUrlService {
  private readonly cdn = enviroment.BASE_URL_CDN_MEDIA;

  project(userId: string, projectId: string | number, fileName: string, size: ImageSizeKey): string {
    const { w, h } = IMAGE_SIZES[size];
    return `${this.cdn}fit-in/${w}x${h}/${userId}/${projectId}/photo/${fileName}`;
  }

  projectStyle(userId: string, projectId: string | number, fileName: string, size: ImageSizeKey): string {
    return `url("${this.project(userId, projectId, fileName, size)}")`;
  }

  social(userId: string, fileName: string, size: ImageSizeKey): string {
    const { w, h } = IMAGE_SIZES[size];
    return `${this.cdn}fit-in/${w}x${h}/${userId}/social/${fileName}`;
  }

  socialStyle(userId: string, fileName: string, size: ImageSizeKey): string {
    return `url("${this.social(userId, fileName, size)}")`;
  }

  /** Converte URLs de mídia social (S3 pré-assinadas ou formato antigo /files/user/) para o CDN.
   *  Blob URLs e URLs já no CDN passam sem alteração. */
  transformSocialUrl(url: string | null | undefined, size: ImageSizeKey): string | null {
    if (!url) return null;
    if (url.startsWith('blob:') || url.includes(this.cdn)) return url;

    // URL pré-assinada do S3: extrai o path ignorando query string
    const s3Match = url.match(/^https?:\/\/[^/]+\.amazonaws\.com\/([^?]+)/);
    if (s3Match) {
      const { w, h } = IMAGE_SIZES[size];
      return `${this.cdn}fit-in/${w}x${h}/${s3Match[1]}`;
    }

    // Formato antigo: /files/user/{userId}/social/{fileName}
    const legacyMatch = url.match(/\/files\/user\/([^/]+)\/social\/(?:thumb_)?(.+)/);
    if (legacyMatch) {
      return this.social(legacyMatch[1], legacyMatch[2], size);
    }

    return url;
  }
}
